import { render, staticRenderFns } from "./ExportStudent.vue?vue&type=template&id=17ed6c70&scoped=true&"
import script from "./ExportStudent.vue?vue&type=script&lang=js&"
export * from "./ExportStudent.vue?vue&type=script&lang=js&"
import style0 from "./ExportStudent.vue?vue&type=style&index=0&id=17ed6c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ed6c70",
  null
  
)

export default component.exports